import {
  PayeeRequirement,
  RequirementStatus
} from "@wingspanhq/wingspan-api-sdk";

import { selectorIsRequirementPostApproval } from "./selectorIsRequirementPostApproval";

export const selectorIsRequirementApproved = (
  requirement: PayeeRequirement
) => {
  const isRequirementComplete =
    requirement.status === RequirementStatus.COMPLETED;

  return (
    selectorIsRequirementPostApproval(requirement) && isRequirementComplete
  );
};
